/**
 * Upload a file to S3 via pre-signed URL using XMLHttpRequest.
 * Extracted for testability — the XHR logic is standalone.
 */
export function uploadToS3(uploadUrl: string, file: File): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const xhr = new XMLHttpRequest()
		xhr.open('PUT', uploadUrl)
		xhr.setRequestHeader('Content-Type', file.type)

		xhr.onload = () => {
			if (xhr.status >= 200 && xhr.status < 300) resolve()
			else reject(new Error(`S3 upload failed with status ${xhr.status}`))
		}
		xhr.onerror = () => reject(new Error('S3 upload failed — network error'))
		xhr.send(file)
	})
}

/**
 * Trigger a browser file download by creating a temporary anchor element.
 */
export function triggerBrowserDownload(url: string, fileName: string): void {
	const link = document.createElement('a')
	link.href = url
	link.download = fileName
	link.click()
}
